import React from 'react'
import Form from 'react-bootstrap/Form';
import CommentSendIcon from "../../../../styles/img/svg/CommentSendIcon.jsx"

export default function UiCommentInput(props) {

    return (
        <>
            <div className='sb-comment-input'>
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder={props.placeholder}
                        value={props.value}
                    />
                    <Form.Control.Feedback type={props.errorType}>
                        {props.errorMsg}
                    </Form.Control.Feedback>
                </Form.Group>
                <span><CommentSendIcon/></span>
            </div>
        </>
    )
}
